import { cn } from "@/shared/lib/utils/cn";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="skeleton" className={cn("animate-pulse bg-muted-foreground/10", className)} {...props} />;
}

export { Skeleton };
